// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1k5wz","col":"styles_col__16_jG"};